import { useMutation } from '@tanstack/react-query';
import type { BulkUpdateCustomFieldsRequest } from '../types/CandidateProfile';

export default function useBulkUpdateCustomFields() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkUpdateCustomFieldsRequest) => {
      const response = await fetch('/agent/api/candidate_profiles/bulk_update_custom_fields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'データの更新に失敗しました');
      return data;
    },
  });
}
